import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';
import type { ComboboxSize } from './Combobox.types';

export {
  Chevron,
  Option,
  OptionsContainer,
  OptionsList,
  SecondaryLabel,
  Wrapper,
} from '../Dropdown/Dropdown.styles';

const HEIGHT_VAR = '--voyager-combobox-height';

export const Field = styled.div<{ $size: ComboboxSize }>`
  display: flex;
  align-items: center;
  gap: ${space['space-200']};
  box-sizing: border-box;
  width: 100%;
  min-width: 100px;
  height: var(
    ${HEIGHT_VAR},
    ${(p) => (p.$size === 'lg' ? primitives.size['size-1400'] : primitives.size['size-1000'])}
  );
  padding: 0 ${(p) => (p.$size === 'lg' ? space['space-400'] : space['space-300'])};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${size.radius['radius-sm']};
  background: ${semantic.bg.canvas};
  color: ${semantic.text.primary};
  cursor: text;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:focus-within,
  &[data-open='true'] {
    border-color: ${semantic.border.selected};
  }

  &[data-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &[data-error='true'] {
    border-color: ${semantic.border.danger};
  }
`;

export const TextInput = styled.input<{ $size: ComboboxSize }>`
  flex: 1;
  min-width: 0;
  height: 100%;
  border: none;
  outline: none;
  padding: 0;
  background: transparent;
  font-family: ${fonts.body};
  font-size: ${(p) => (p.$size === 'lg' ? fonts.size.base : fonts.size.sm)};
  color: inherit;
  text-overflow: ellipsis;

  &::placeholder {
    color: ${semantic.text.tertiary};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const OptionText = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: ${space['space-200']} 0;
  min-width: 0;

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const OptionSubtext = styled.span`
  color: ${semantic.text.secondary};
  font-size: ${fonts.size.sm};
`;

export const StatusRow = styled.li`
  display: flex;
  align-items: center;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  padding: ${space['space-300']} ${space['space-600']};
  color: ${semantic.text.tertiary};
  cursor: default;

  &[data-tone='error'] {
    color: ${semantic.text.danger};
  }
`;

export const ListFooter = styled.div`
  flex-shrink: 0;
  padding: ${space['space-300']} ${space['space-600']} 0;
  border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  margin-top: ${space['space-300']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
`;
